import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Inbox } from 'lucide-react';
import { API } from '../App';
import { DropdownMenuItem, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger } from './ui/dropdown-menu';

export const MaintenanceRequestsMenu = () => {
  const navigate = useNavigate();
  const [locations, setLocations] = useState(null);

  useEffect(() => {
    axios.get(`${API}/locations`).then((r) => setLocations(r.data || [])).catch(() => setLocations([]));
  }, []);

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger data-testid="menu-maintenance-requests-btn">
        <Inbox className="mr-2 h-4 w-4" />
        Maintenance Requests
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent data-testid="menu-maintenance-requests-list">
        {locations === null && <DropdownMenuItem disabled>Loading…</DropdownMenuItem>}
        {locations?.length === 0 && <DropdownMenuItem disabled>No locations yet</DropdownMenuItem>}
        {locations?.map((loc) => (
          <DropdownMenuItem key={loc.id} onSelect={() => navigate(`/location/${loc.id}/maintenance-requests`)}
            data-testid={`menu-maintenance-requests-${loc.id}`}>
            {loc.name}
          </DropdownMenuItem>
        ))}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
};
